/* seic-article-carousel.js — SEIC 文章互動元件漸進增強（零依賴）
   1) 輪播 [data-seic-carousel]：無 JS 時仍可原生手勢橫滑；本檔補藥丸指示條、
      滑鼠拖曳、鍵盤與 aria（三改移除箭頭；七改移除圖說鏡射、
      藥丸由 CSS 疊到圖片上；十九改移除滾輪攔截——滾輪交給瀏覽器原生捲動）
   2) Tab 分頁 [data-seic-tabs]：無 JS 時三張圖直排顯示；本檔補點選切換
   3) 懸浮分類選單 [data-seic-float]：<1024 收合軌的開合（七改：toggle＝
      覆蓋整條黑軌的透明熱區，展開後讓位給連結）、overlay/Esc 收合、回頂鈕
   4) 低解析度圖片守門（十四改）：滿版 figure 若原圖寬度不足以撐 100vw，
      自動掛 .is-lowres 退回文字欄寬，避免放大糊掉（門檻與理由見 guardLowResImages）
   5) 互動圖表 [data-seic-viz]：讀內文表格畫成可點選的圖，無 JS 時就是那張表（見 initViz） */
(function () {
  'use strict';

  function initTabs(root) {
    if (root.dataset.seicInit) return;
    root.dataset.seicInit = '1';
    var lis = Array.prototype.slice.call(root.querySelectorAll('.seic-tabs__nav li'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('.seic-tabs__panel'));
    if (lis.length < 2 || lis.length !== panels.length) return;

    var nav = root.querySelector('.seic-tabs__nav');
    nav.setAttribute('role', 'tablist');

    function activate(idx) {
      lis.forEach(function (li, i) {
        li.setAttribute('aria-selected', i === idx ? 'true' : 'false');
        li.setAttribute('tabindex', i === idx ? '0' : '-1');
      });
      panels.forEach(function (p, i) {
        p.classList.toggle('is-active', i === idx);
      });
    }

    lis.forEach(function (li, i) {
      li.setAttribute('role', 'tab');
      li.addEventListener('click', function () { activate(i); });
      li.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); activate(i); }
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault();
          var next = (i + (e.key === 'ArrowRight' ? 1 : lis.length - 1)) % lis.length;
          activate(next);
          lis[next].focus();
        }
      });
    });
    panels.forEach(function (p) { p.setAttribute('role', 'tabpanel'); });

    root.classList.add('seic-tabs--ready');
    activate(0);
  }

  function initCarousel(root) {
    if (root.dataset.seicInit) return;
    root.dataset.seicInit = '1';

    var track = root.querySelector('.seic-carousel__track');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    if (slides.length < 2) return;

    var prefersReduced = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var scrollBehavior = prefersReduced ? 'auto' : 'smooth';

    root.setAttribute('role', 'region');
    root.setAttribute('aria-roledescription', '輪播');
    root.setAttribute('aria-label', root.getAttribute('aria-label') || '圖片輪播');
    track.setAttribute('tabindex', '0');

    var currentIndex = 0;

    // 目標捲動位置：讓第 i 張靠左貼齊（2026-08-24 十四改，對應 CSS 的
    // scroll-snap-align: start——center 對齊的非循環輪播首末張必然留白，
    // 使用者要求兩端補滿版位）。用「相對第 0 張」而不是絕對 offsetLeft，
    // 這樣 track 日後若再加回 padding 也不會算錯。
    function targetLeft(i) {
      var raw = slides[i].offsetLeft - slides[0].offsetLeft;
      return Math.max(0, Math.min(raw, track.scrollWidth - track.clientWidth));
    }
    function goTo(i, behavior) {
      i = Math.max(0, Math.min(i, slides.length - 1));
      track.scrollTo({ left: targetLeft(i), behavior: behavior || scrollBehavior });
    }

    // 藥丸指示條：active 圓點拉長成條狀（iPhone 式；取代舊圓點與 >5 張 counter）
    var pill = document.createElement('div');
    pill.className = 'seic-carousel__pill';
    var pillInner = document.createElement('div');
    pillInner.className = 'seic-carousel__pill-inner';
    var dotEls = slides.map(function (_slide, i) {
      var d = document.createElement('button');
      d.type = 'button';
      d.className = 'seic-carousel__dot';
      d.setAttribute('aria-label', '第 ' + (i + 1) + ' 張，共 ' + slides.length + ' 張');
      if (i === 0) d.setAttribute('aria-current', 'true');
      d.addEventListener('click', function () { goTo(i); });
      pillInner.appendChild(d);
      return d;
    });
    pill.appendChild(pillInner);
    root.appendChild(pill);

    // （2026-08-24 七改移除圖說鏡射：使用者指示輪播不顯示圖說。
    // 各 slide 的 figcaption 由 CSS 收 sr-only，語意仍保留給螢幕閱讀器。）

    // 螢幕閱讀器進度通知（藥丸沒有文字 counter，補一個 sr-only live region）
    var live = document.createElement('span');
    live.className = 'seic-visually-hidden';
    live.setAttribute('aria-live', 'polite');
    live.textContent = '第 1 張，共 ' + slides.length + ' 張';
    root.appendChild(live);

    function updateActive(idx) {
      if (idx === currentIndex) return;
      currentIndex = idx;
      dotEls.forEach(function (d, i) {
        if (i === idx) d.setAttribute('aria-current', 'true');
        else d.removeAttribute('aria-current');
      });
      slides.forEach(function (s, i) { s.classList.toggle('is-current', i === idx); });
      live.textContent = '第 ' + (idx + 1) + ' 張，共 ' + slides.length + ' 張';
    }
    slides[0].classList.add('is-current');

    // 狀態由 scroll 事件驅動（勿改回 IntersectionObserver——hidden document 不派發）
    var scrollTimer = null;
    function syncFromScroll() {
      var x = track.scrollLeft;
      var best = 0;
      var bestDist = Infinity;
      for (var i = 0; i < slides.length; i++) {
        var d = Math.abs(targetLeft(i) - x);
        if (d < bestDist) { bestDist = d; best = i; }
      }
      updateActive(best);
    }
    track.addEventListener('scroll', function () {
      if (scrollTimer) clearTimeout(scrollTimer);
      scrollTimer = setTimeout(syncFromScroll, 100);
    }, { passive: true });

    /* 滾輪：**不攔截**（十九改，2026-09-16 使用者拍板移除三改加的「滾輪切換」）。
       舊做法把游標下的任何滾輪事件（含上下捲頁）都攔成「翻一張＋鎖 450ms」，
       正式站實測：滑鼠往下滾 3 格→頁面不動、輪播翻 1 張、另 2 格被吃掉；
       觸控板橫撥一次（含慣性幾十個事件）→ 翻 2 張；翻頁動畫 0.5s 比鎖還長，
       狀態常沒更新就「感覺沒翻」。使用者：「異常的跳轉……根本沒有自然的感覺」。
       現在：上下滾交給頁面（游標在不在輪播上都一樣），左右撥交給瀏覽器原生橫向
       捲動＋CSS 的 scroll-snap 在手勢結束時停在整張圖上（撥多遠走多遠、有慣性）。
       圓點、滑鼠拖曳、鍵盤 ←→ 照舊。**不要再加回 wheel 監聽**——要「一撥只翻一張」
       得先解決 macOS 手勢起訖在 wheel 事件裡看不到的問題，否則一定回到上面那些症狀。 */

    // 滑鼠拖曳（觸控本來就有原生手勢，只處理 mouse pointer）
    var dragging = false;
    var dragged = false;
    var dragStartX = 0;
    var dragStartScroll = 0;
    track.addEventListener('dragstart', function (e) { e.preventDefault(); }); // 擋原生圖片拖出
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      dragging = true;
      dragged = false;
      dragStartX = e.clientX;
      dragStartScroll = track.scrollLeft;
      track.classList.add('is-dragging'); // 關 snap，拖起來才不黏滯
      track.setPointerCapture(e.pointerId);
    });
    track.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var delta = dragStartX - e.clientX;
      if (Math.abs(delta) > 4) dragged = true;
      track.scrollLeft = dragStartScroll + delta;
    });
    function endDrag() {
      if (!dragging) return;
      dragging = false;
      syncFromScroll();
      var delta = track.scrollLeft - dragStartScroll;
      var target = currentIndex;
      // 拖超過 60px 就翻頁（往拖曳方向），不足則彈回當前張
      if (delta > 60 && currentIndex < slides.length - 1) target = currentIndex + 1;
      else if (delta < -60 && currentIndex > 0) target = currentIndex - 1;
      goTo(target);
      // 平滑歸位後再恢復 snap（歸位點＝snap 點，恢復瞬間不會跳）
      setTimeout(function () { track.classList.remove('is-dragging'); }, prefersReduced ? 0 : 380);
    }
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    // 拖曳後吞掉合成 click（保險：slide 內若日後有連結不會誤觸）
    track.addEventListener('click', function (e) {
      if (dragged) { e.preventDefault(); e.stopPropagation(); dragged = false; }
    }, true);

    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
        e.preventDefault();
        goTo(currentIndex + (e.key === 'ArrowLeft' ? -1 : 1));
      } else if (e.key === 'Home') {
        e.preventDefault();
        goTo(0);
      } else if (e.key === 'End') {
        e.preventDefault();
        goTo(slides.length - 1);
      }
    });

    root.classList.add('seic-carousel--ready');
  }

  // 懸浮分類選單 rail：開合狀態單一來源＝.is-open（CSS :hover/:focus-within
  // 只是無 JS fallback，兩者語意一致不衝突）
  function initFloat(root) {
    if (root.dataset.seicInit) return;
    root.dataset.seicInit = '1';

    var nav = root.querySelector('.seic-category-nav');
    var toggle = root.querySelector('[data-seic-float-toggle]');
    var overlay = root.querySelector('[data-seic-float-close]');
    var topBtn = root.querySelector('[data-seic-float-top]');
    if (!nav || !toggle) return;

    var prefersReduced = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var hoverable = !!(window.matchMedia && window.matchMedia('(hover: hover)').matches);
    // ≥1024px 是「常駐黑軌」態：四格永遠在畫面上、toggle 與 overlay 都 display:none，
    // 沒有開合這回事（圖卡的推出純 CSS :hover）。開合邏輯只服務 <1024 的收合面板。
    var railMQ = window.matchMedia ? window.matchMedia('(min-width: 1024px)') : null;
    function isRail() { return !!(railMQ && railMQ.matches); }

    function isOpen() { return root.classList.contains('is-open'); }
    function setOpen(v) {
      root.classList.toggle('is-open', v);
      toggle.setAttribute('aria-expanded', v ? 'true' : 'false');
    }

    if (hoverable) {
      nav.addEventListener('pointerenter', function () { if (!isRail()) setOpen(true); });
      nav.addEventListener('pointerleave', function () { if (!isRail()) setOpen(false); });
    }
    toggle.addEventListener('click', function (e) {
      if (isRail()) return;
      // 有滑鼠的裝置由 hover 主導；滑鼠點擊不再 toggle（否則 hover 開啟後
      // 一點反而關閉）。鍵盤 Enter/Space 的合成 click 是 detail 0，放行。
      if (hoverable && e.detail > 0) return;
      setOpen(!isOpen());
    });
    if (overlay) overlay.addEventListener('click', function () { setOpen(false); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen()) setOpen(false);
    });

    if (topBtn) {
      topBtn.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: prefersReduced ? 'auto' : 'smooth' });
      });
      var onScroll = function () {
        topBtn.classList.toggle('is-visible', (window.scrollY || 0) > 600);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  }

  /* 圖片畫質守門（2026-08-24 十四改）
     ── 先修真正的病根：sizes 過期 ──
     pipeline 在 780px 欄寬時代寫死 `sizes="(min-width:1024px) 780px, 100vw"`
     （optimize.py SIZES_VALUE）。版型改滿版後那行沒跟上，瀏覽器**照舊只挑 780px
     的候選**再被 CSS 拉到 1920——srcset 裡明明有 1200/1500 的版本沒被用到。
     實測：naturalWidth 全是 780，而 srcset 最大值是 1200–1500。
     這才是使用者說「糊、馬賽克」的主因，不是原圖不夠大。
     pipeline 那行已同步改成 100vw（未來文章直接是對的）；這裡再對**既有文章**
     即時修正，同事沿用舊 HTML 貼上時也能自動救回。
     代價：改 sizes 後瀏覽器會重挑候選，首次瀏覽可能多下載一次小圖（一次性）。

     ── 再判斷原圖能力 ──
     判定要看 **srcset 的最大候選**（pipeline 產 srcset 時已夾在原圖寬度內，
     那才是「這張圖最高能給到多少像素」）；naturalWidth 只反映「當下載入的那個
     尺寸」，會被 sizes 影響，拿來判斷等於用結果當原因。

     門檻的演變：
     - 1400（2026-08-24）：照 1920 一般螢幕訂，放大 1.37 倍「肉眼輕微」。
     - 2000（2026-09-04，使用者拍板）：retina 螢幕一個點用四個像素畫，1512 視窗的
       滿版要 3024 像素，1400 的圖會放大 2.2 倍，使用者在 Timberland 聯名篇肉眼看出糊。
       2000 = 一般螢幕 1:1、retina 最多 1.5 倍（管線 srcset 的天花板也是 2000，
       所以這已經是「有多少給多少」的上限，不是保守）。原則：太小的圖不硬放大。
     管線（optimize.py 的 FULLBLEED_MIN_SOURCE_WIDTH）現在會**靜態**掛 --narrow，
     這裡是給沒經過管線的 HTML（同事手貼）與舊文章的第二道保險；兩邊的數字要一起改。
     只看原圖能力、不看當下視窗寬度——結果可預測，也不必在 resize 時重算。 */
  var FULLBLEED_MIN_SOURCE_WIDTH = 2000;
  var FULLBLEED_SIZES = '100vw';

  function maxSourceWidth(img) {
    var ss = img.getAttribute('srcset');
    if (ss) {
      var widths = [];
      ss.replace(/(\d+)w/g, function (_m, w) { widths.push(+w); return _m; });
      if (widths.length) return Math.max.apply(null, widths);
    }
    return img.naturalWidth || 0; // 沒有 srcset 才退回實際載入尺寸
  }

  /* 十七改（2026-09-03，使用者指示）：輪播也要守門。
     門檻取 900＝slide 舞台自身最寬值（.seic-carousel__slide 的 flex-basis
     min(86vw, 900px)），語意是「絕不放大超過原圖」——不同於單圖的 1400（那是
     容忍 1920/1400≈1.37 倍的滿版放大），因為輪播舞台本來就只有 900。
     實測：門檻放 800 或 1400 結果一樣（線上 6 組輪播都是 4 組退窄），
     取 900 是因為它能用一句話解釋，不是湊出來的數字。

     用**最弱**的那張決定整組：slide 共用同一個舞台寬，一張糊就整組看得出來，
     而輪播是左右滑的連續體，不能一張窄一張寬。 */
  var CAROUSEL_MIN_SOURCE_WIDTH = 900;

  /* 十八改（2026-09-16，使用者拍板）：窄版輪播也要等高。
     窄版解除 3:2 統一裁切是為了「不裁到人」（十七改），代價是每張照片各自比例——
     同一組裡 4 張 2:3、最後一張 3:4，那張就矮 124px（The Green Machine 篇，使用者發現）。
     全站掃過：25 組輪播、12 組窄版、其中 4 組比例不一。
     做法：以該組**最多張共用的比例**為準（同票取先出現的）；用 cover 裁齊時裁掉
     ≤ 20% 的照片裁齊（門檻與滿版單圖「裁掉超過 20% 就退窄」同一條線，見
     optimize.NARROW_MAX_AR／newpost.FULLBLEED_MAX_CROP 的 0.20），超過的維持自己的
     比例不裁——Cargo Bike 調查那組正方對 3:2 要裁掉三成、會切到頭，寧可高低不齊。
     裁掉多少 = 1 − min(r, t) ÷ max(r, t)（r＝這張高÷寬、t＝基準）：比基準高的裁上下、
     比基準寬的裁左右，兩種算出來都是這個式子。 */
  var CAROUSEL_UNIFY_MAX_CROP = 0.20;

  function slideRatio(img) {
    var w = parseInt(img.getAttribute('width'), 10);
    var h = parseInt(img.getAttribute('height'), 10);
    return (w > 0 && h > 0) ? { r: h / w, css: w + ' / ' + h } : null;
  }

  function dominantRatio(imgs) {
    var counts = {}, first = {}, order = [];
    Array.prototype.forEach.call(imgs, function (img) {
      var s = slideRatio(img);
      if (!s) return;
      var key = s.r.toFixed(2);
      if (!(key in counts)) { counts[key] = 0; first[key] = s; order.push(key); }
      counts[key]++;
    });
    var best = null;
    order.forEach(function (key) { if (best === null || counts[key] > counts[best]) best = key; });
    return best === null ? null : first[best];
  }

  function guardLowResCarousels(root) {
    var cars = root.querySelectorAll('.seic-article > .seic-carousel');
    Array.prototype.forEach.call(cars, function (car) {
      var imgs = car.querySelectorAll('.seic-carousel__slide img');
      if (!imgs.length) return;
      var weakest = Infinity, unknown = false;
      Array.prototype.forEach.call(imgs, function (img) {
        var capable = maxSourceWidth(img);
        if (!capable) { unknown = true; return; }
        if (capable < weakest) weakest = capable;
      });
      if (weakest !== Infinity) {
        var narrow = weakest < CAROUSEL_MIN_SOURCE_WIDTH;
        car.classList.toggle('is-lowres', narrow);
        /* 窄版解除了 CSS 的 `aspect-ratio: 3/2`，但那條規則同時兼著「圖還沒載入時
           先把高度佔好」的工作——換成 auto 之後，尚未載入的 lazy slide 內在比例
           是未知的，高度直接變 0（實測 Cargo Bike 那篇 5 張有 3 張是 742x0），
           左右滑的時候會一路跳版。`aspect-ratio: revert` 救不回來（試過）。
           改成從 img 自己的 width／height 屬性算比例蓋上去：管線一定會寫這兩個
           屬性（README 圖片規則），所以每張都拿得到正確的預留高度，
           載入前後高度一致、不裁切、左緣也還是貼齊文字。 */
        var target = narrow ? dominantRatio(imgs) : null;
        Array.prototype.forEach.call(imgs, function (img) {
          if (!narrow) { img.style.aspectRatio = ''; img.classList.remove('is-unified'); return; }
          var s = slideRatio(img);
          if (!s) { img.style.aspectRatio = ''; img.classList.remove('is-unified'); return; }
          // 十八改：與基準差得少的裁齊（cover），差得多的保留自己的比例（contain）
          var crop = target ? 1 - Math.min(s.r, target.r) / Math.max(s.r, target.r) : 1;
          var unify = !!target && crop <= CAROUSEL_UNIFY_MAX_CROP;
          img.style.aspectRatio = unify ? target.css : s.css;
          img.classList.toggle('is-unified', unify);
        });
      }
      if (unknown) {
        // 有圖還沒載入且沒有 srcset → 等載完再判一次（同單圖的後備路徑）
        Array.prototype.forEach.call(imgs, function (img) {
          if (maxSourceWidth(img)) return;
          img.addEventListener('load', function () { guardLowResCarousels(root); }, { once: true });
        });
      }
    });
  }

  function guardLowResImages(root) {
    var figs = root.querySelectorAll('.seic-article > figure');
    Array.prototype.forEach.call(figs, function (fig) {
      var img = fig.querySelector('img');
      if (!img) return;
      // `seic-figure--narrow` 是**人／管線決定**這張不要滿版（直式圖滿版會裁掉
      // 人和車；或原圖真細節不足 2000、不硬放大）。它的 sizes 是文字欄寬，不能被
      // 下面那行改回 100vw——改了就變成宣告 1440 卻只畫 806，白下載一倍多的位元組。
      // 2026-09-03 加：在那之前這裡無差別覆蓋，管線寫的 NARROW_SIZES 等於白寫。
      // 2026-09-04 加：已經是 --narrow 的就整個跳過。管線把 --narrow 的 srcset 夾在
      // 1600，門檻升到 2000 後每一張都會被這裡誤標 is-lowres——版面一樣，但下一個
      // 讀 class 的人會以為是原圖不夠格。
      var narrow = fig.classList.contains('seic-figure--narrow');
      if (narrow) { fig.classList.remove('is-lowres'); return; }
      var capable = maxSourceWidth(img);
      var lowres = capable > 0 && capable < FULLBLEED_MIN_SOURCE_WIDTH;
      fig.classList.toggle('is-lowres', lowres);
      // 夠格滿版的才把 sizes 開到 100vw（降級的維持窄欄，不必下載大圖）
      if (!lowres && !narrow && img.getAttribute('srcset') && img.getAttribute('sizes') !== FULLBLEED_SIZES) {
        img.setAttribute('sizes', FULLBLEED_SIZES);
      }
      if (!capable) {
        // srcset 缺失且尚未載入 → 等 load 後用 naturalWidth 再判一次
        img.addEventListener('load', function () {
          fig.classList.toggle('is-lowres', img.naturalWidth > 0 && img.naturalWidth < FULLBLEED_MIN_SOURCE_WIDTH);
        }, { once: true });
      }
    });
  }

  /* ---------- 5) 互動圖表 [data-seic-viz]（2026-11-02） ----------
     內文只放一般 <table>（資料唯一來源，改數字只改表格），本段讀表格畫成可點選的圖。
     無 JS／搜尋引擎看到的仍是表格；畫好後表格收起，「以表格檢視」可切回。
       range：列＝車系、欄＝電輔段位，格子寫「65 km」「75–90 km」「∞ km」「-」
       road ：列＝路況；欄標題含「電力」的是車款（括號寫刻度，如「（0–5）」，
              單速車加「單速」二字）、含「變速」的是共用的變速刻度、含「為什麼」的是說明。
              某車款某路況的格子寫「—」＝這個車款不顯示這個路況
     車款照片與「馬達／齒盤」在照片上的位置在 VIZ_BIKES（照片是去背白底商品照；
     座標是照片寬高的比例 0–1）。新增車款：補一筆，名稱用 match 對到表格裡的車款名。 */
  var VIZ_CDN = 'https://cdn.shopify.com/s/files/1/0824/0182/0959/files/';
  var VIZ_BIKES = [
    { match: /minibike|miniswing/i, img: 'minibike_bk_front_view.jpg' },
    { match: /miniu/i, img: 'product_miniu_classic_black_2_2207884f-1c6f-4903-8abe-a4f6eebdb0e4.jpg',
      hub: [0.19, 0.575] },
    { match: /UDX/i, img: 'product_UDX_black_2_8431ed44-8908-4c43-97dc-85e97aea0acc.jpg',
      hub: [0.215, 0.61], gear: [0.15, 0.655] },
    { match: /Unimoke|MK|SW/i, img: 'product_MK_Table.jpg',
      hub: [0.2, 0.625], gear: [0.165, 0.69] }
  ];
  function vizBike(name) {
    for (var i = 0; i < VIZ_BIKES.length; i++) if (VIZ_BIKES[i].match.test(name)) return VIZ_BIKES[i];
    return null;
  }
  function vizImg(file, w) { return VIZ_CDN + file + '?width=' + w; }

  function vizText(el) { return (el.textContent || '').replace(/\s+/g, ' ').trim(); }

  // 「約 3–4」「關閉或最低 0–1」「65 km」→ [lo, hi]；找不到數字回 null
  function vizSpan(text) {
    var m = text.match(/(\d+)\s*[–~\-－]\s*(\d+)/);
    if (m) return [+m[1], +m[2]];
    m = text.match(/\d+/);
    return m ? [+m[0], +m[0]] : null;
  }

  function vizEl(tag, cls, text) {
    var el = document.createElement(tag);
    if (cls) el.className = cls;
    if (text != null) el.textContent = text;
    return el;
  }

  var SVGNS = 'http://www.w3.org/2000/svg';
  function vizSvg(tag, attrs, parent) {
    var el = document.createElementNS(SVGNS, tag);
    for (var k in attrs) el.setAttribute(k, attrs[k]);
    if (parent) parent.appendChild(el);
    return el;
  }

  /* 路況小插圖（120×64）：地面線＋一台小車，起步加紅綠燈、逆風加風線。
     依路況名稱的關鍵字挑畫法，認不得的就畫平路。 */
  function vizScene(name) {
    var svg = vizSvg('svg', { viewBox: '0 0 120 64', 'aria-hidden': 'true', focusable: 'false' });
    var ink = { stroke: 'currentColor', 'stroke-width': 2, fill: 'none', 'stroke-linecap': 'round', 'stroke-linejoin': 'round' };
    var slope = 0, y0 = 54;   // slope：地面每 100px 爬升多少（正＝上坡）
    if (/陡/.test(name)) slope = 44;
    else if (/上坡|緩坡/.test(name)) slope = 30;
    else if (/下坡/.test(name)) slope = -30;
    var yL = slope > 0 ? 58 : slope < 0 ? 58 + slope : y0;
    var yR = slope > 0 ? 58 - slope : slope < 0 ? 58 : y0;
    vizSvg('line', Object.assign({ x1: 6, y1: yL, x2: 114, y2: yR }, ink), svg);
    // 小車：兩輪＋車架，放在地面上、跟著坡度轉
    var bx = /起步|紅綠燈/.test(name) ? 36 : /逆風/.test(name) ? 34 : 54;
    var by = yL + (yR - yL) * (bx - 6) / 108;
    var ang = Math.atan2(yR - yL, 108) * 180 / Math.PI;
    var g = vizSvg('g', { transform: 'translate(' + bx + ' ' + by + ') rotate(' + ang + ')' }, svg);
    vizSvg('circle', Object.assign({ cx: -10, cy: -7, r: 6 }, ink), g);
    vizSvg('circle', Object.assign({ cx: 10, cy: -7, r: 6 }, ink), g);
    vizSvg('path', Object.assign({ d: 'M-10 -7 L-3 -17 L7 -17 L10 -7 M-3 -17 L0 -7 L-10 -7 M7 -17 L9 -22 L13 -22 M-5 -20 L0 -20' }, ink), g);
    if (/起步|紅綠燈/.test(name)) {
      vizSvg('rect', Object.assign({ x: 86, y: 8, width: 12, height: 30, rx: 2 }, ink), svg);
      vizSvg('line', Object.assign({ x1: 92, y1: 38, x2: 92, y2: y0 }, ink), svg);
      vizSvg('circle', { cx: 92, cy: 15, r: 3, fill: 'currentColor', opacity: 0.25 }, svg);
      vizSvg('circle', { cx: 92, cy: 23, r: 3, fill: 'currentColor', opacity: 0.25 }, svg);
      vizSvg('circle', { cx: 92, cy: 31, r: 3.4, 'class': 'seic-viz__lit' }, svg);
    } else if (/逆風/.test(name)) {
      ['M112 16 H72 q-6 0 -6 -5 q0 -4 4 -4', 'M114 28 H64', 'M110 40 H76 q-5 0 -5 4 q0 4 4 4'].forEach(function (d) {
        vizSvg('path', Object.assign({ d: d }, ink, { 'stroke-width': 1.6 }), svg);
      });
    } else if (/平/.test(name)) {
      ['M24 36 H34', 'M20 42 H32'].forEach(function (d) {
        vizSvg('path', Object.assign({ d: d }, ink, { 'stroke-width': 1.6 }), svg);
      });
    }
    return svg;
  }

  /* 一排互斥卡片：opts[i] = { name, img? , scene? }；回傳容器，container.pick(i) 切換 */
  function vizCards(cls, label, opts, onPick) {
    var box = vizEl('div', 'seic-viz__cards ' + cls);
    box.setAttribute('role', 'group');
    box.setAttribute('aria-label', label);
    var btns = opts.map(function (o, i) {
      var b = vizEl('button', 'seic-viz__card');
      b.type = 'button';
      if (o.img) {
        var im = vizEl('img');
        im.src = vizImg(o.img, 360);
        im.alt = '';
        im.width = 180;
        im.height = 180;
        im.loading = 'lazy';
        im.decoding = 'async';
        b.appendChild(im);
      } else if (o.scene) {
        b.appendChild(vizScene(o.name));
      }
      b.appendChild(vizEl('span', 'seic-viz__card-name', o.name));
      b.addEventListener('click', function () { pick(i); });
      box.appendChild(b);
      return b;
    });
    function pick(i) {
      btns.forEach(function (b, j) { b.setAttribute('aria-pressed', i === j ? 'true' : 'false'); });
      onPick(i);
    }
    box.pick = pick;
    box.btns = btns;
    return box;
  }

  // 表格／圖切換鈕：表格本身留在原位，只切換顯示
  function vizTableToggle(root, wrap) {
    var btn = vizEl('button', 'seic-viz__toggle', '以表格檢視');
    btn.type = 'button';
    btn.setAttribute('aria-expanded', 'false');
    btn.addEventListener('click', function () {
      var open = root.classList.toggle('seic-viz--table');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? '收起表格' : '以表格檢視';
    });
    wrap.parentNode.insertBefore(btn, wrap);
  }

  function initVizRange(root, table) {
    var heads = Array.prototype.map.call(table.querySelectorAll('thead th'), vizText);
    var series = Array.prototype.map.call(table.querySelectorAll('tbody tr'), function (tr) {
      var cells = tr.children;
      var rows = [];
      for (var c = 1; c < cells.length; c++) {
        var t = vizText(cells[c]);
        var lvl = (heads[c] || '').match(/\d+/);
        if (!lvl || !/\d|∞/.test(t)) continue;
        if (/∞/.test(t)) { rows.push({ lvl: +lvl[0], free: true }); continue; }
        var s = vizSpan(t);
        if (s) rows.push({ lvl: +lvl[0], lo: s[0], hi: s[1] });
      }
      return { name: vizText(cells[0]), rows: rows };
    }).filter(function (s) { return s.rows.length; });
    if (!series.length) return false;

    // 全部車系共用同一把尺，切換車系時長條長度可直接比較
    var max = 0;
    series.forEach(function (s) { s.rows.forEach(function (r) { if (r.hi > max) max = r.hi; }); });

    var ui = vizEl('div', 'seic-viz__ui');
    var chart = vizEl('div', 'seic-viz__bars');
    chart.setAttribute('aria-live', 'polite');
    var note = vizEl('p', 'seic-viz__note');

    function draw(i) {
      var s = series[i];
      chart.textContent = '';
      var ranged = false;
      s.rows.forEach(function (r) {
        var row = vizEl('div', 'seic-viz__bar');
        row.appendChild(vizEl('span', 'seic-viz__lvl', r.lvl + ' 段'));
        var track = vizEl('span', 'seic-viz__track');
        var val;
        if (r.free) {
          row.classList.add('is-free');
          val = '純踩踏・不耗電';
        } else {
          var lo = vizEl('span', 'seic-viz__fill');
          lo.style.width = (r.lo / max * 100) + '%';
          track.appendChild(lo);
          if (r.hi > r.lo) {
            ranged = true;
            var hi = vizEl('span', 'seic-viz__fill seic-viz__fill--up');
            hi.style.left = (r.lo / max * 100) + '%';
            hi.style.width = ((r.hi - r.lo) / max * 100) + '%';
            track.appendChild(hi);
            val = r.lo + '–' + r.hi + ' km';
          } else {
            val = r.lo + ' km';
          }
        }
        row.appendChild(track);
        row.appendChild(vizEl('span', 'seic-viz__val', val));
        chart.appendChild(row);
      });
      note.textContent = ranged ? '淺色段＝依體重、路況、踩踏而定的可達區間' : '';
      note.hidden = !ranged;
    }

    var cards = vizCards('seic-viz__cards--bike', '選擇車系', series.map(function (s) {
      var b = vizBike(s.name);
      return { name: s.name, img: b && b.img };
    }), draw);
    ui.appendChild(cards);
    ui.appendChild(chart);
    ui.appendChild(note);
    cards.pick(0);
    return ui;
  }

  // 一條刻度：from..to 的格子，lo..hi 亮起來
  function vizMeter(kind, label, where, from, to, span, unit) {
    var box = vizEl('div', 'seic-viz__meter seic-viz__meter--' + kind);
    var head = vizEl('div', 'seic-viz__meter-head');
    var name = vizEl('span', 'seic-viz__meter-name');
    name.appendChild(vizEl('i', 'seic-viz__dot seic-viz__dot--' + kind));
    name.appendChild(document.createTextNode(label));
    head.appendChild(name);
    var lit = span[0] === span[1] ? String(span[0]) : span[0] + '–' + span[1];
    head.appendChild(vizEl('strong', 'seic-viz__meter-val', lit + ' ' + unit));
    box.appendChild(head);
    if (where) box.appendChild(vizEl('span', 'seic-viz__meter-where', where));
    var scale = vizEl('div', 'seic-viz__scale');
    scale.setAttribute('aria-hidden', 'true');
    scale.style.gridTemplateColumns = 'repeat(' + (to - from + 1) + ', 1fr)';
    for (var n = from; n <= to; n++) {
      scale.appendChild(vizEl('span', 'seic-viz__cell' + (n >= span[0] && n <= span[1] ? ' is-on' : ''), String(n)));
    }
    box.appendChild(scale);
    return box;
  }

  /* 車款照片＋標示：粉圈＝後輪馬達（電力輔助）、黑圈＝後齒盤（機械變速）。
     標籤放在照片左上／左下角，用引線連到部位——兩個部位都在後輪軸附近、靠得很近，
     標籤直接貼在點旁邊會疊在一起。 */
  function vizBikeFigure(bike, name, power, gears) {
    var fig = vizEl('div', 'seic-viz__bike');
    var im = vizEl('img');
    im.src = vizImg(bike.img, 900);
    im.alt = name + ' 側面照，標出後輪馬達' + (bike.gear ? '與後齒盤' : '') + '的位置';
    im.width = 800;
    im.height = 800;
    im.loading = 'lazy';
    im.decoding = 'async';
    fig.appendChild(im);
    var svg = vizSvg('svg', { viewBox: '0 0 100 100', preserveAspectRatio: 'none', 'aria-hidden': 'true', 'class': 'seic-viz__leads' }, fig);
    function mark(kind, pt, tagPos, title, val) {
      vizSvg('line', { x1: tagPos[0], y1: tagPos[1], x2: pt[0] * 100, y2: pt[1] * 100, 'class': 'seic-viz__lead seic-viz__lead--' + kind, 'vector-effect': 'non-scaling-stroke' }, svg);
      var ring = vizEl('span', 'seic-viz__ring seic-viz__ring--' + kind);
      ring.style.left = (pt[0] * 100) + '%';
      ring.style.top = (pt[1] * 100) + '%';
      fig.appendChild(ring);
      var tag = vizEl('span', 'seic-viz__tag seic-viz__tag--' + kind);
      tag.style.left = tagPos[0] + '%';
      tag.style.top = tagPos[1] + '%';
      tag.appendChild(vizEl('span', 'seic-viz__tag-name', title));
      tag.appendChild(vizEl('strong', 'seic-viz__tag-val', val));
      fig.appendChild(tag);
    }
    function lit(s, unit) { return (s[0] === s[1] ? s[0] : s[0] + '–' + s[1]) + ' ' + unit; }
    mark('power', bike.hub, [4, 22], '電力輔助・後輪馬達', lit(power, '段'));
    if (bike.gear && gears) mark('gear', bike.gear, [4, 90], '機械變速・後齒盤', lit(gears, '檔'));
    return fig;
  }

  function initVizRoad(root, table) {
    var heads = Array.prototype.map.call(table.querySelectorAll('thead th'), vizText);
    var models = [], gear = -1, why = -1;
    heads.forEach(function (h, i) {
      var paren = (h.match(/（[^）]*）|\([^)]*\)/) || [''])[0];
      if (/電力/.test(h)) {
        models.push({ col: i, name: h.replace(/\s*電力.*$/, ''), scale: vizSpan(paren) || [0, 5], single: /單速/.test(paren) });
      } else if (/變速/.test(h)) gear = i;
      else if (/為什麼|說明/.test(h)) why = i;
    });
    if (!models.length || gear < 0) return false;
    var gearScale = vizSpan((heads[gear].match(/（[^）]*）|\([^)]*\)/) || [''])[0]) || [1, 7];
    var roads = Array.prototype.map.call(table.querySelectorAll('tbody tr'), function (tr) {
      return Array.prototype.map.call(tr.children, vizText);
    });
    if (!roads.length) return false;
    // 這個車款有資料的路況（格子裡有數字）
    function has(m, r) { return !!vizSpan(roads[r][models[m].col] || ''); }

    var state = { m: 0, r: 0 };
    var ui = vizEl('div', 'seic-viz__ui');
    var stage = vizEl('div', 'seic-viz__stage');
    stage.setAttribute('aria-live', 'polite');

    function draw() {
      var m = models[state.m], row = roads[state.r];
      var bike = vizBike(m.name);
      var power = vizSpan(row[m.col] || '') || [0, 0];
      var gears = m.single ? null : (vizSpan(row[gear] || '') || gearScale);
      stage.textContent = '';
      if (bike && bike.hub) stage.appendChild(vizBikeFigure(bike, m.name, power, gears));
      var read = vizEl('div', 'seic-viz__readout');
      read.appendChild(vizEl('p', 'seic-viz__readout-title', m.name + '｜' + row[0]));
      read.appendChild(vizMeter('power', '電力輔助', '後輪馬達出力，在把手儀表上調', m.scale[0], m.scale[1], power, '段'));
      if (gears) {
        read.appendChild(vizMeter('gear', '機械變速', '後齒盤換檔，用右手變速把手調', gearScale[0], gearScale[1], gears, '檔'));
        if (why >= 0 && row[why] && !/^[—\-–]$/.test(row[why])) read.appendChild(vizEl('p', 'seic-viz__why', row[why]));
      } else {
        read.appendChild(vizEl('p', 'seic-viz__why', m.name + ' 是單速車，沒有機械變速：維持穩定順暢的踩踏，依路況調整電力段位就好。'));
      }
      stage.appendChild(read);
    }

    var roadCards = vizCards('seic-viz__cards--scene', '選擇路況', roads.map(function (r) {
      return { name: r[0], scene: true };
    }), function (i) { state.r = i; draw(); });

    // 換車款：沒資料的路況收起來；目前選的路況沒資料就跳到第一個有資料的
    function syncRoads() {
      var first = -1;
      roadCards.btns.forEach(function (b, r) {
        var ok = has(state.m, r);
        b.hidden = !ok;
        if (ok && first < 0) first = r;
      });
      roadCards.pick(has(state.m, state.r) ? state.r : first);
    }
    var modelCards = vizCards('seic-viz__cards--bike', '選擇車款', models.map(function (m) {
      var b = vizBike(m.name);
      return { name: m.name, img: b && b.img };
    }), function (i) { state.m = i; syncRoads(); });

    ui.appendChild(vizEl('p', 'seic-viz__step', '① 選車款'));
    ui.appendChild(modelCards);
    ui.appendChild(vizEl('p', 'seic-viz__step', '② 選路況'));
    ui.appendChild(roadCards);
    ui.appendChild(stage);
    modelCards.pick(0);
    return ui;
  }

  function initViz(root) {
    if (root.dataset.seicInit) return;
    var wrap = root.querySelector('.seic-table-wrap');
    var table = root.querySelector('table');
    if (!wrap || !table) return;
    var kind = root.getAttribute('data-seic-viz');
    var ui = kind === 'range' ? initVizRange(root, table)
           : kind === 'road' ? initVizRoad(root, table) : false;
    if (!ui) return;   // 表格格式不認得：什麼都不做，表格照常顯示
    root.dataset.seicInit = '1';
    root.insertBefore(ui, wrap);
    vizTableToggle(root, wrap);
    root.classList.add('seic-viz--ready');
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-seic-carousel]'), initCarousel);
    Array.prototype.forEach.call(document.querySelectorAll('[data-seic-tabs]'), initTabs);
    Array.prototype.forEach.call(document.querySelectorAll('[data-seic-viz]'), initViz);
    Array.prototype.forEach.call(document.querySelectorAll('[data-seic-float]'), initFloat);
    guardLowResImages(document);
    guardLowResCarousels(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
